export const getSlackValue = (state) => {
	return state.setSlackValue;
}